import 'styles/fonts.scss';
import 'styles/globals.css';
import 'styles/overrideStyles.scss';
import { FC } from 'react';
import Modal from 'react-modal';

import { wrapper } from 'app-redux/store/store';
import { MainContainer } from 'components/dynamic';

Modal.setAppElement('#__next');
const MyApp: FC<any> = ({ Component }) => (
  // @ts-ignore
  <MainContainer>
    <Component />
  </MainContainer>
);

export default wrapper.withRedux(MyApp);
